/**
 * ? @description : Create Teacher By Admin
 */

// Dependencies
import React, {  useState } from "react";
import { Row, Col, Container, Button, Spinner } from "react-bootstrap";

// Axios Component
import Axios from "../teacherapi/TeacherApi";

// CSS Component
import "../../App.css";

// Components
// import TitleBar from "./Components/header/TitleBar";
import PrimaryInfo from "../lte-teacher-volunteer/PrimaryInfo";
import APRInfo from "../lte-teacher-volunteer/APRInfo";
import PrereqInfo from "../lte-teacher-volunteer/PrereqInfo";
import ThankyouModal from '../thankyou-modal/ThankyouModal'
import { Stepper, Step } from 'react-form-stepper';
// import ParentInfo from "./Components/lte-teacher-volunteer/ParentInfo";

function FormInfo() {

  // * Logged User Name
  const username = sessionStorage.getItem("username");

  // * State Variables
  const [page, setPage] = useState(0);
  const [show, handleShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    teacher_name: "",
    contactno: "",
    email: "",
    is_apr_residing: "",
    apr_homeaddress: "",
    city:"",
    apr_reference_contact: "",
    // have_student_already: "",
    tentative_start_date: "",
    role: "volunteer",
    teacher_status: "active",
    group_status: "ungrouped",
    teacher_mapped_status: "unmapped",
    audio_status: "unsubmitted",
    is_commitment_three_months: false,
    is_agreed_lte_policy: false,
    spoke_lang_1: "",
    spoke_lang_2: "",
    spoke_lang_3: "",
    spoke_lang_4: "",
    spoke_lang_5: "",
    spoke_lang_6: "",
    apr_reference_name: "",
    group_id: null,
    group_name: null,
    mapped_to_student: null,
    batch_member_id: null,
    map_id: null,
    note_description: null,
    created_by: username,
    isOTPVerified: false
    // address: "",
    // pincode: "",
    // country: "",
    // city: "",
    // is_above_ninth_grade: "",
    // parent_name: "",
    // parent_contactno: "",
  });
  
  const [validationRes, setValidationRes] = useState({
    isInvalidTeacherName: false,
    isInvalidTeacherNameFormate: false,
    isInvalidTeacherMobileNumber: false,
    isInvalidTeacherMobileNumberFormate: false,
    isInvalidTeacherMailId: false,
    isInvalidSpokenLanguage1: false,
    isInvalidCity:false, // added on 10-12-2025
    isInvalidStartDate: false,
   isInvalidOTP: false,
  //  isInvalidAprResiding: false, // Added on 12-08-2022 // commeneted on 10-12-2025
   // isInvalidAprHomeAddress: false, // Added on 12-08-2022
   // isInvalidAprReferenceNumber: false, // Added on 07-11-2022
   // isInvalidAprReferenceName: false, // Added on 07-11-2022
    //sInvalidAprReferenceNumberFormate: false,
    //isInvalidAprReferenceNameFormate: false,
    //isInvalidHaveStudentAlready: false, // Added on 12-08-2022
    // isInvalidTeacherHomeAddress: false,
    // isInvalidTeacherPincode: false,
    // isInvalidTeacherCountry: false,
    // isInvalidTeacherState: false,
    // isInvalidParentName: false,
    // isInvalidParentMobileNumber: false,
    // isInvalidAboveNinthGrade: false, // Added on 12-08-2022
  });

  // * Initialize Header in Array Format
  const FormTitles = [
    "Primary Information",
    "Residence Information",
    "Other information",
    // "Parent Information",
  ];

  const backdropSpinner = (
    <div id="backdrop">
      <Spinner style={{
        display: "block",
        position: "fixed",
        top: "calc(50% - (58px / 2))",
        right: "calc(50% - (58px / 2))",
      }} animation="border" variant="primary" />
    </div>
  )

  // * Condition to Render Form Data Tab
  const PageDisplay = () => {
    if (page === 0) {
      return (
        <PrimaryInfo
          formData={formData}
          setFormData={setFormData}
          validationRes={validationRes}
          setValidationRes={setValidationRes}
        />
      );
    } else if (page === 1) {
      return (
        <APRInfo
          formData={formData}
          setFormData={setFormData}
          validationRes={validationRes}
          setValidationRes={setValidationRes}
        />
      );
    } else {
      return (
        <PrereqInfo
          formData={formData}
          setFormData={setFormData}
          validationRes={validationRes}
          setValidationRes={setValidationRes}
        />
      );
    }
    // else {
    //   return (
    //     <ParentInfo
    //       formData={formData}
    //       setFormData={setFormData}
    //       validationRes={validationRes}
    //       setValidationRes={setValidationRes}
    //     />
    //   );
    // }
  };

  // TODO : Email Validation Pattern
  // const checkInvalidEmail = (email) => {
  //   var pattern = new RegExp(
  //     /^(([\w.+-]+)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  //   );
  //   var result = pattern.test(email);
  //   return !result;
  // };


  // TODO : Mobile number Validation Pattern
  const checkInvalidNumber = (number) => {
    var pattern = new RegExp(
      /^\d+$/
    );
    var result = pattern.test(number);
    return !result;
  }

  // TODO : Name field validation pattern 

  const checkInvalidName = (name) => {
    var pattern = new RegExp(/^\s*[a-zA-Z]+(?:\s+[a-zA-Z]+)*\s*$/);
    var result = pattern.test(name);
    return !result;
  }


  // TODO : Validate Primary Tab Form Fields
  const primaryValidation = () => {
    var canMoveToNextPage = true;
    var invalidName = false;
    var invalidMobile = false;
    var invalidNameFormate = false;
    var invalidMobileFormate = false;
    var invalidEmail = false;
    var invalidSpokenLang1 = false;
    var invalidOTP = false;

    if (
      formData.teacher_name.length === 0 ||
      formData.teacher_name.length > 50
    ) {
      invalidName = true;
      canMoveToNextPage = false;
    } else if (checkInvalidName(formData.teacher_name)) {
      invalidNameFormate = true;
      canMoveToNextPage = false;
    }

    if (!(formData.contactno.length === 10)) {
      invalidMobile = true;
      canMoveToNextPage = false;
    } else {
      if (checkInvalidNumber(formData.contactno)) {
        invalidMobileFormate = true;
        canMoveToNextPage = false;
      }
    }

    if (formData.email.length === 0) {
      invalidEmail = true;
      canMoveToNextPage = false;
    }
    // else {
    //   if (checkInvalidEmail(formData.email)) {
    //     invalidEmail = true;
    //     canMoveToNextPage = false;
    //   }
    // }

    if (
      formData.spoke_lang_1.length === 0 ||
      formData.spoke_lang_1.length > 20
    ) {
      canMoveToNextPage = false;
      invalidSpokenLang1 = true;
    }

    if(!formData.isOTPVerified){
      canMoveToNextPage = false;
      invalidOTP = true;
    }

    setValidationRes({
      ...validationRes,
      isInvalidTeacherName: invalidName,
      isInvalidTeacherMobileNumber: invalidMobile,
      isInvalidTeacherMailId: invalidEmail,
      isInvalidTeacherNameFormate: invalidNameFormate,
      isInvalidTeacherMobileNumberFormate: invalidMobileFormate,
      isInvalidSpokenLanguage1: invalidSpokenLang1,
      isInvalidOTP: invalidOTP
    });
    return canMoveToNextPage;
  };

  // TODO : Validate APR Tab Form Fields
  const aprValidation = () => {
    let canMoveToNextPage = true;
   //  var invalidAprHomeAddress = false;
   let invalidCity= false // added on 10-12-2025
   //   var invalidResiding = false commented on 10-12-2025
   // var invalidAprMobile = false; commented on 10-12-2025;
   // var invalidAprName = false; commented on 10-12-2025;
   // var invalidAprMobileFormate = false; commented on 10-12-2025;
    // var invalidAprNameFormate = false; commented on 10-12-2025;
    // var invalidPincode = false; commented on 10-12-2025;
    // var invalidCountry = false; commented on 10-12-2025;
    // var invalidState = false;commented on 10-12-2025;

    // if (formData.city) {

    //   if (formData.is_apr_residing.length === 0) {
    //     invalidResiding = true;
    //     canMoveToNextPage = false;
    //   }
    //   if (formData.city.length === 0) {
    //     invalidCity = true;
    //     canMoveToNextPage = false;
    //   }
    // }
    //  else {
    //   if (!(formData.apr_reference_contact.length === 10)) {
    //     invalidAprMobile = true;
    //     canMoveToNextPage = false;
    //   } else {
    //     if (checkInvalidNumber(formData.apr_reference_contact)) {
    //       invalidAprMobileFormate = true;
    //       canMoveToNextPage = false;
    //     }
    //   }

    //   if (formData.apr_reference_name.length === 0 || formData.apr_reference_name.length > 20) {
    //     invalidAprName = true;
    //     canMoveToNextPage = false;
    //   } else if (checkInvalidName(formData.apr_reference_name)) {
    //     invalidAprNameFormate = true;
    //     canMoveToNextPage = false;
    //   }
    // }     commennted on 10-12-2025



    /*if (!(formData.pincode.length === 6)) {
      invalidPincode = true;
      canMoveToNextPage = false;
    }

    if (formData.country.length === 0 || formData.country.length > 30) {
      invalidCountry = true;
      canMoveToNextPage = false;
    }

    if (formData.city.length === 0 || formData.city.length > 30) {
      invalidState = true;
      canMoveToNextPage = false;
    } */

        if (!formData.city || formData.city.length === 0) {
    invalidCity = true;
    canMoveToNextPage = false;
  }
    setValidationRes({
      ...validationRes,
      // isInvalidAprResiding: invalidResiding  commennted on 10-12-2025,
      isInvalidCity: invalidCity,
      // isInvalidAprReferenceNumber: invalidAprMobile commennted on 10-12-2025,
      // isInvalidAprReferenceName: invalidAprName commennted on 10-12-2025,
      // isInvalidAprReferenceNumberFormate: invalidAprMobileFormate commennted on 10-12-2025,
      // isInvalidAprReferenceNameFormate: invalidAprNameFormate,
      /*isInvalidTeacherHomeAddress: invalidAddress,
      isInvalidTeacherPincode: invalidPincode,
      isInvalidTeacherCountry: invalidCountry,
      isInvalidTeacherState: invalidState, */
    });
    return canMoveToNextPage;
  };

  // TODO : Validate Pre-Requisite Tab Form Fields
  const prereqValidation = () => {
    var canMoveToNextPage = true;
    // var invalidAboveNinthGrade = false;
    var invalidHaveStudentAlready = false;
    var invalidTentativeDate = false;

    /* if (formData.is_above_ninth_grade.length === 0) {
      invalidAboveNinthGrade = true;
      canMoveToNextPage = false;
    } */

    // if (formData.have_student_already.length === 0) {
    //   invalidHaveStudentAlready = true;
    //   canMoveToNextPage = false;
    // }

    if (formData.tentative_start_date.length === 0) {
      invalidTentativeDate = true;
      canMoveToNextPage = false;
    }

    setValidationRes({
      ...validationRes,
      // isInvalidAboveNinthGrade: invalidAboveNinthGrade,
      isInvalidHaveStudentAlready: invalidHaveStudentAlready,
      isInvalidStartDate: invalidTentativeDate,
    });
    return canMoveToNextPage;
  };

  // TODO : Validate Parent Tab Form Fields
  /* const parentValidation = () => {
    var canMoveToNextPage = true;
    var invalidParentName = false;
    var invalidParentNumber = false;

    if (formData.parent_name.length === 0 || formData.parent_name.length > 20) {
      invalidParentName = true;
      canMoveToNextPage = false;
    }

    if (!(formData.parent_contactno.length === 10)) {
      invalidParentNumber = true;
      canMoveToNextPage = false;
    }

    setValidationRes({
      ...validationRes,
      isInvalidParentName: invalidParentName,
      isInvalidParentMobileNumber: invalidParentNumber,
    });
    return canMoveToNextPage;
  }; */

  // ? Post Method : API Call to Submit Teacher Data
  async function postData() {
    try {
      setLoading(true);
      let options = {
        method: "POST",
        url: "/teacher",
        auth: true,
        data: formData,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 201) {
        // alert("Form data submitted successfully !");
        handleShow(true);
        setLoading(false);
        // window.location.reload();      

      } else {
        setLoading(false);
        alert(response.data.message)
      }

    } catch (error) {
      alert("Error occurred ! Please try again later.");
      setLoading(false);
    }
  }
  // console.log(formData);
  return (
    <div>

      <Row>
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 8, offset: 2 }}
          lg={{ span: 8, offset: 2 }}
          xl={{ span: 6, offset: 3 }}
        >
          <Container>
            <h2 className="mt-3 lte-teacher-title">
              Register to volunteer
            </h2>

            {/* Progress Bar */}
            {/* <span className="progressbar-percent">
              Page&nbsp;:&nbsp;
              {page === 0 ? "1 of 3" : page === 1 ? "2 of 3" : "3 of 3"}
            </span>

            <div className="progressbar">
              <div
                style={{
                  width: page === 0 ? "33.33%" : page === 1 ? "66.66%" : "100%",
                }}
              ></div>
            </div> */}
            <Stepper styleConfig={{
              activeBgColor: '#1D3FAA',
              completedBgColor: '#446beb',
              // activeTextColor: '#fff',
              // inactiveBgColor: '#fff',
              // inactiveTextColor: '#2b7cff',
              // completedBgColor: '#fff',
              // completedTextColor: '#2b7cff',
              // size: '3em'
            }}
              activeStep={page}
            >
              <Step label="Primary Information" />
              <Step label="Residence Information" />
              <Step label="Other information" />
            </Stepper>

            {/* Form Page Title */}
            <h3 className="lte-form-title-tab">{FormTitles[page]}</h3>

            {/* Form Data */}
            {PageDisplay()}

            {/* Buttons */}
            <div className="com-btn mb-5">
              {page !== 0 && <Button
                type="button"
                variant="success"
                className="mr-3 lte-prev-button"
                onClick={() => setPage((currPage) => currPage - 1)}
                disabled={page === 0}
              >
                Previous
              </Button>}

              {page === FormTitles.length - 1 && (
                <Button
                  type="button"
                  variant="warning"
                  className="ml-3 lte-prev-button"
                  onClick={() => window.location.reload()}
                >
                  Reset
                </Button>
              )}

              {page === FormTitles.length - 1 && (
                <Button
                  type="button"
                  variant="danger"
                  className="ml-3 lte-prev-button"
                  onClick={() => window.location.reload()}
                >
                  Cancel
                </Button>
              )}

              <Button
                variant="primary"
                className="ml-3 lte-next-button"
                onClick={() => {
                  if (page === 0) {
                    var isValid = primaryValidation();
                    if (isValid) setPage((currPage) => currPage + 1);
                    else
                      alert("Please fill all the mandatory fields.");
                  }
                  if (page === 1) {
                    var isValid_2 = aprValidation();
                    if (isValid_2) {
                      setPage((currPage) => currPage + 1);
                    } else {
                      alert("Please fill all the mandatory fields.");
                    }
                  }
                  if (page === FormTitles.length - 1) {
                    var isValid_3 = prereqValidation();
                    if (isValid_3) {
                      postData();
                    } else {
                      alert("Please fill all the mandatory fields.");
                    }
                  }
                  // if (page === FormTitles.length - 1) {
                  //   var isValid_4 = parentValidation();
                  //   if (isValid_4) {
                  //     postData();
                  //   }
                  // }
                }}
              >
                {page === FormTitles.length - 1 ? "Submit" : "Next"}
              </Button>
            </div>
          </Container>
        </Col>
      </Row>


      <ThankyouModal show={show} onHide={() => handleShow(false)}></ThankyouModal>
      {loading && backdropSpinner}

      <p className="product">
        Designed & Powered by <a href="https://blackwinstech.com/"      rel="noreferrer"
 target="_blank"> Blackwins Tech Solutions</a>
      </p>
    </div>
  );
}

export default FormInfo;